// Projects Management Permissions

export const PROJECTS_INDEX = 268;
export const PROJECTS_CREATE = 269;
export const PROJECTS_UPDATE = 270;
export const PROJECTS_DELETE = 271;
export const PROJECTS_RESTORE = 1398;
export const PROJECTS_SHOW = PROJECTS_INDEX;
// Attaching properties to a project is a project update.
export const PROJECTS_ASSIGN_PROPERTIES = PROJECTS_UPDATE;
export const PROJECTS_VIEW_PROPERTIES = 274;
export const PROJECTS_VIEW_CONTRACTS = 275;
export const PROJECTS_VIEW_INVOICES = 276;
export const PROJECTS_VIEW_INFO = PROJECTS_INDEX;
